import React, { useState } from 'react';
import { Field, Formik } from 'formik';
import { InputField } from 'Modules/Formik';
import { Button, Form } from 'semantic-ui-react';
import IconLogin from 'Assets/images/manadr-rectangle.svg';
import { EmailPasswordBody } from 'Types';

import { getOtpMethodName } from './constants';
import SelectOTPMethodModal from './SelectOTPMethodModal';
import validation from './validation';
import styles from './Login.less';
import { Status } from './Login';

const initialValues = {
  email: '',
  password: '',
};

type AppProps = {
  onSubmit: (body: EmailPasswordBody) => void;
  statusLogin: Status;
  otpMethod: number;
  setOtpMethod: (otpMethod: number) => void;
};

const PasswordEmail = ({ onSubmit, statusLogin, otpMethod, setOtpMethod }: AppProps) => {
  const { loading, error } = statusLogin;
  const otpMethodName = getOtpMethodName(otpMethod);

  const [openModal, setOpenModal] = useState(false);

  const handleOnSubmit = values => {
    onSubmit(values);
  };

  return (
    <>
      <Formik initialValues={initialValues} onSubmit={handleOnSubmit} validationSchema={validation}>
        {({ handleSubmit }) => (
          <Form onSubmit={handleSubmit}>
            <img className={styles.logo} src={IconLogin} alt="manadr login head" />
            <div className={styles.title}>Log in</div>
            <div className={styles.subTitle}>Welcome back! Please enter your details</div>
            <Field
              name="email"
              label="Email"
              component={InputField}
              disabled={loading}
              placeholder="Email"
            />
            <Field
              name="password"
              label="Password"
              component={InputField}
              type="password"
              disabled={loading}
              placeholder="Password"
            />
            {error && <p style={{ color: 'red' }}>{error}</p>}
            <div className={styles.actions}>
              <Button
                style={{
                  backgroundColor: '#0984e3',
                  fontWeight: '600',
                  fontSize: '14px',
                  height: '44px',
                  marginTop: '24px',
                }}
                disabled={loading}
                loading={loading}
                primary
                fluid
                content="Send OTP"
                type="submit"
              />
            </div>
          </Form>
        )}
      </Formik>
      <div className={styles.methodText}>
        Receive OTP via <strong className={styles.method}>{otpMethodName}</strong>.{' '}
        <span className={styles.changeMethodBtn} onClick={() => setOpenModal(true)}>
          Change
        </span>
      </div>
      <SelectOTPMethodModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        initMethod={otpMethod}
        onSave={setOtpMethod}
      />
    </>
  );
};

export default PasswordEmail;
